import {useState} from "react";
import {toast} from "react-hot-toast";
import {InventoryService} from "./Service";

const AddUnit = () => {
    const service = new InventoryService();
    const [name, setName] = useState('');
    const [symbol, setSymbol] = useState('');
    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (name === '' || symbol === '') {
            toast.error('Please fill all the required fields');
            return;
        }
        const res = await service.addUnit({
            name: name,
            symbol: symbol,
        });

        if (res) {
            toast.success('Unit added successfully');
            setName('');
            setSymbol('');
        }
    }

    return (
        <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Add Unit</h5>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit} className="row">
                        <div className="col-lg-12">
                            <div className="form-title">
                                <h5>General Information</h5>
                            </div>
                        </div>

                        <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                                <label>Name <span className="text-danger">(required)</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter user name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                                <label>Symbol <span className="text-danger">(required)</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter symbol"
                                    value={symbol}
                                    onChange={(e) => setSymbol(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="btn-path text-end">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-cancel bg-primary-light me-3"
                                    onClick={() => {
                                        window.history.back();
                                    }}
                                >
                                    Back
                                </a>
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default AddUnit;